import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { isAuthenticated, getUser } from '../lib/auth';
import { useSubdomain } from '../hooks/useSubdomain';
import { LandingPage } from './LandingPage';
import { Loader2 } from 'lucide-react';

export function HomePage() {
  const navigate = useNavigate();
  const { isLandingPage, isResidences } = useSubdomain();

  useEffect(() => {
    // On residences subdomain, use existing auth redirect logic
    if (isResidences) {
      if (isAuthenticated()) {
        const user = getUser();
        if (user?.role === 'system_admin' || user?.role === 'building_admin') {
          navigate('/admin');
        } else if (user?.role === 'resident') {
          navigate('/dashboard');
        } else if (user?.role === 'organization_admin') {
          navigate('/org-admin/buildings');
        } else {
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    }
    // On landing domain, just render (no redirect)
  }, [navigate, isResidences]);

  // Landing page content
  if (isLandingPage) {
    return <LandingPage />;
  }

  // Loading state while redirecting
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
